const moltiplicatori = { 
    0: 0, 1: 1, 2: 1.1, 3: 1.2, 4: 1.3, 5: 1.5,
    6: 1.7, 7: 1.9, 8: 2.1, 9: 2.3,
    10: 2.75773, 11: 2.91941, 12: 3.07459, 13: 3.22456, 14: 3.37024,
    15: 3.5123, 16: 3.65125, 17: 3.78749, 18: 3.92129, 19: 4.05292,
    20: 4.18254, 21: 4.31033, 22: 4.4364, 23: 4.56086, 24: 4.68379,
    25: 4.80527, 26: 4.92536, 27: 5.04411, 28: 5.16157, 29: 5.27777,
    30: 5.39275, 31: 5.50654, 32: 5.61916, 33: 5.73064, 34: 5.84099,
    35: 5.95024, 36: 6.0584, 37: 6.16548, 38: 6.27149, 39: 6.37645,
    40: 6.48037, 41: 6.58326, 42: 6.68512, 43: 6.78596, 44: 6.88578,
    45: 6.98461, 46: 7.08243, 47: 7.17926, 48: 7.2751, 49: 7.36995,
    50: 7.46382, 51: 7.55671, 52: 7.64863, 53: 7.73958, 54: 7.82955,
    55: 7.91857, 56: 8.00661, 57: 8.0937, 58: 8.17983, 59: 8.265,
    60: 8.34922, 61: 8.43248, 62: 8.5148, 63: 8.59616, 64: 8.67657,
    65: 8.75604, 66: 8.83456, 67: 8.91214, 68: 8.98877, 69: 9.06446,
    70: 9.13921, 71: 9.21302, 72: 9.28588, 73: 9.35781, 74: 9.42881,
    75: 9.49886, 76: 9.56798, 77: 9.63616, 78: 9.70341, 79: 9.76972,
    80: 9.8351, 81: 9.89954, 82: 9.96305, 83: 10.02563, 84: 10.08728,
    85: 10.14799, 86: 10.20778, 87: 10.26663, 88: 10.32456, 89: 10.38155,
    90: 10.43762, 91: 10.49275, 92: 10.54696, 93: 10.60023, 94: 10.65258,
    95: 10.70401, 96: 10.7545, 97: 10.80407, 98: 10.8527, 99: 10.90042,
    100: 10.9472
  };

const demoltiplicatori = { 
    0: 1, 1: 1, 2: 0.995, 3: 0.99, 4: 0.985, 5: 0.98, 6: 0.975, 7: 0.97,
    8: 0.965, 9: 0.96, 10: 0.955, 11: 0.95, 12: 0.945, 13: 0.94, 14: 0.935,
    15: 0.93, 16: 0.925, 17: 0.92, 18: 0.915, 19: 0.91, 20: 0.905, 21: 0.901,
    22: 0.896, 23: 0.891, 24: 0.886, 25: 0.881, 26: 0.876, 27: 0.871, 28: 0.866,
    29: 0.861, 30: 0.856, 31: 0.851, 32: 0.846, 33: 0.841, 34: 0.836, 35: 0.831,
    36: 0.826, 37: 0.821, 38: 0.816, 39: 0.811, 40: 0.806, 41: 0.801, 42: 0.797,
    43: 0.792, 44: 0.787, 45: 0.782, 46: 0.777, 47: 0.772, 48: 0.767, 49: 0.762,
    50: 0.757, 51: 0.752, 52: 0.747, 53: 0.742, 54: 0.738, 55: 0.733, 56: 0.728,
    57: 0.723, 58: 0.718, 59: 0.713, 60: 0.708, 61: 0.703, 62: 0.698, 63: 0.694,
    64: 0.689, 65: 0.684, 66: 0.679, 67: 0.674, 68: 0.669, 69: 0.664, 70: 0.66,
    71: 0.655, 72: 0.65, 73: 0.645, 74: 0.64, 75: 0.636, 76: 0.631, 77: 0.626,
    78: 0.621, 79: 0.617, 80: 0.612, 81: 0.607, 82: 0.602, 83: 0.598, 84: 0.593,
    85: 0.588, 86: 0.584, 87: 0.579, 88: 0.574, 89: 0.57, 90: 0.565, 91: 0.56,
    92: 0.556, 93: 0.551, 94: 0.547, 95: 0.542, 96: 0.537, 97: 0.533, 98: 0.529,
    99: 0.525, 100: 0.522
  };

const coefficientiMoraleBiologico = { 
    0: { min: 0.210, med: 0.260, max: 0.310 },
    1: { min: 0.210, med: 0.260, max: 0.310 },
    2: { min: 0.210, med: 0.260, max: 0.310 },
    3: { min: 0.210, med: 0.260, max: 0.310 },
    4: { min: 0.210, med: 0.260, max: 0.310 },
    5: { min: 0.210, med: 0.260, max: 0.310 },
    6: { min: 0.210, med: 0.260, max: 0.310 },
    7: { min: 0.210, med: 0.260, max: 0.310 },
    8: { min: 0.210, med: 0.260, max: 0.310 },
    9: { min: 0.210, med: 0.260, max: 0.310 },
    10: { min: 0.210, med: 0.260, max: 0.310 },
    11: { min: 0.241, med: 0.291, max: 0.341 },
    12: { min: 0.253, med: 0.303, max: 0.353 },
    13: { min: 0.263, med: 0.313, max: 0.363 },
    14: { min: 0.271, med: 0.321, max: 0.371 },
    15: { min: 0.278, med: 0.328, max: 0.378 },
    16: { min: 0.285, med: 0.335, max: 0.385 },
    17: { min: 0.291, med: 0.341, max: 0.391 },
    18: { min: 0.296, med: 0.346, max: 0.396 },
    19: { min: 0.302, med: 0.352, max: 0.402 },
    20: { min: 0.307, med: 0.357, max: 0.407 },
    21: { min: 0.311, med: 0.361, max: 0.411 },
    22: { min: 0.316, med: 0.366, max: 0.416 },
    23: { min: 0.320, med: 0.370, max: 0.420 },
    24: { min: 0.324, med: 0.374, max: 0.424 },
    25: { min: 0.328, med: 0.378, max: 0.428 },
    26: { min: 0.332, med: 0.382, max: 0.432 },
    27: { min: 0.336, med: 0.386, max: 0.436 },
    28: { min: 0.340, med: 0.390, max: 0.440 },
    29: { min: 0.343, med: 0.393, max: 0.443 },
    30: { min: 0.347, med: 0.397, max: 0.447 },
    31: { min: 0.350, med: 0.400, max: 0.450 },
    32: { min: 0.353, med: 0.403, max: 0.453 },
    33: { min: 0.357, med: 0.407, max: 0.457 },
    34: { min: 0.360, med: 0.410, max: 0.460 },
    35: { min: 0.363, med: 0.413, max: 0.463 },
    36: { min: 0.366, med: 0.416, max: 0.466 },
    37: { min: 0.369, med: 0.419, max: 0.469 },
    38: { min: 0.372, med: 0.422, max: 0.472 },
    39: { min: 0.375, med: 0.425, max: 0.475 },
    40: { min: 0.377, med: 0.427, max: 0.477 },
    41: { min: 0.380, med: 0.430, max: 0.480 },
    42: { min: 0.383, med: 0.433, max: 0.483 },
    43: { min: 0.386, med: 0.436, max: 0.486 },
    44: { min: 0.388, med: 0.438, max: 0.488 },
    45: { min: 0.391, med: 0.441, max: 0.491 },
    46: { min: 0.393, med: 0.443, max: 0.493 },
    47: { min: 0.396, med: 0.446, max: 0.496 },
    48: { min: 0.398, med: 0.448, max: 0.498 },
    49: { min: 0.401, med: 0.451, max: 0.501 },
    50: { min: 0.403, med: 0.453, max: 0.503 },
    51: { min: 0.406, med: 0.456, max: 0.506 },
    52: { min: 0.408, med: 0.458, max: 0.508 },
    53: { min: 0.410, med: 0.460, max: 0.510 },
    54: { min: 0.413, med: 0.463, max: 0.513 },
    55: { min: 0.415, med: 0.465, max: 0.515 },
    56: { min: 0.417, med: 0.467, max: 0.517 },
    57: { min: 0.420, med: 0.470, max: 0.520 },
    58: { min: 0.422, med: 0.472, max: 0.522 },
    59: { min: 0.424, med: 0.474, max: 0.524 },
    60: { min: 0.426, med: 0.476, max: 0.526 },
    61: { min: 0.428, med: 0.478, max: 0.528 },
    62: { min: 0.430, med: 0.480, max: 0.530 },
    63: { min: 0.433, med: 0.483, max: 0.533 },
    64: { min: 0.435, med: 0.485, max: 0.535 },
    65: { min: 0.437, med: 0.487, max: 0.537 },
    66: { min: 0.439, med: 0.489, max: 0.539 },
    67: { min: 0.441, med: 0.491, max: 0.541 },
    68: { min: 0.443, med: 0.493, max: 0.543 },
    69: { min: 0.445, med: 0.495, max: 0.545 },
    70: { min: 0.447, med: 0.497, max: 0.547 },
    71: { min: 0.449, med: 0.499, max: 0.549 },
    72: { min: 0.451, med: 0.501, max: 0.551 },
    73: { min: 0.453, med: 0.503, max: 0.553 },
    74: { min: 0.455, med: 0.505, max: 0.555 },
    75: { min: 0.456, med: 0.506, max: 0.556 },
    76: { min: 0.458, med: 0.508, max: 0.558 },
    77: { min: 0.460, med: 0.510, max: 0.560 },
    78: { min: 0.462, med: 0.512, max: 0.562 },
    79: { min: 0.464, med: 0.514, max: 0.564 },
    80: { min: 0.466, med: 0.516, max: 0.566 },
    81: { min: 0.468, med: 0.518, max: 0.568 },
    82: { min: 0.469, med: 0.519, max: 0.569 },
    83: { min: 0.471, med: 0.521, max: 0.571 },
    84: { min: 0.473, med: 0.523, max: 0.573 },
    85: { min: 0.475, med: 0.525, max: 0.575 },
    86: { min: 0.476, med: 0.526, max: 0.576 },
    87: { min: 0.478, med: 0.528, max: 0.578 },
    88: { min: 0.480, med: 0.530, max: 0.580 },
    89: { min: 0.482, med: 0.532, max: 0.582 },
    90: { min: 0.483, med: 0.533, max: 0.583 },
    91: { min: 0.485, med: 0.535, max: 0.585 },
    92: { min: 0.487, med: 0.537, max: 0.587 },
    93: { min: 0.488, med: 0.538, max: 0.588 },
    94: { min: 0.490, med: 0.540, max: 0.590 },
    95: { min: 0.492, med: 0.542, max: 0.592 },
    96: { min: 0.493, med: 0.543, max: 0.593 },
    97: { min: 0.495, med: 0.545, max: 0.595 },
    98: { min: 0.497, med: 0.547, max: 0.597 },
    99: { min: 0.498, med: 0.548, max: 0.598 },
    100:{ min: 0.500, med: 0.550, max: 0.600 },
  };


// Interpolate the monetary awards, rather than their coefficients.
export function calculatePermanentDamage(value, age, pointValue, moralLevel, ageCoefficients) {
  const points = Number(String(value ?? '').replace(',', '.'));
  if (!Number.isFinite(points) || points < 0 || points > 100) return { biologico: 0, morale: 0 };
  const integerAward = point => {
    const annualFactor = Array.isArray(ageCoefficients) ? ageCoefficients[Math.max(1, Math.min(100, Math.trunc(age))) - 1] : demoltiplicatori[age];
    const ageFactor = point <= 9 ? (age >= 11 ? 1 - (age - 10) * 0.005 : 1) : annualFactor;
    const biologico = point * moltiplicatori[point] * ageFactor * Number(pointValue);
    const morale = moralLevel ? biologico * (coefficientiMoraleBiologico[point]?.[moralLevel] || 0) : 0;
    return { biologico, morale };
  };
  const lower = Math.floor(points), upper = Math.ceil(points);
  const before = integerAward(lower);
  if (lower === upper) return before;
  const after = integerAward(upper), fraction = points - lower;
  return {
    biologico: before.biologico + (after.biologico - before.biologico) * fraction,
    morale: before.morale + (after.morale - before.morale) * fraction
  };
}

// For fractional points, show the effective increase from the interpolated awards.
export function getMoralIncreasePercentage(points, age, level, ageCoefficients) {
  const award = calculatePermanentDamage(points, age, 1, level, ageCoefficients);
  return award.biologico > 0 ? award.morale / award.biologico * 100 : 0;
}
